import { useOfflineOutbox } from "@/hooks/useOfflineOutbox";
import { cn } from "@/lib/utils";

/** Mutatja a függő offline tételeket; a flush a hookban automatikus. */
export function OfflineOutboxBanner({ className }: { className?: string }) {
  const { count, flushing } = useOfflineOutbox();
  if (count === 0 && !flushing) return null;
  return (
    <div
      role="status"
      className={cn(
        "border-b border-sky-300 bg-sky-100 px-4 py-2 text-center text-sm font-medium text-sky-950 dark:border-sky-800 dark:bg-sky-950/80 dark:text-sky-100",
        className
      )}
      data-testid="offline-outbox-banner"
    >
      {flushing
        ? "Offline várólista szinkronizálása…"
        : `${count} offline tétel vár szinkronra (kiadás / napló / fotó).`}
    </div>
  );
}
